import CRUDServiceOperations from "./CRUDServiceOperations";

class ClassificationService extends CRUDServiceOperations {
  getClassificationsByType(
    type,
    callback,
    failureCallback,
    pageInfo = undefined,
    sortInfo = undefined
  ) {
    const url = type._links.classificationChildren.href;
    return this.getEntitiesWithParams(
      url,
      pageInfo,
      sortInfo,
      callback,
      failureCallback
    );
  }

  getClassificationsChildren(
    parent,
    callback,
    failureCallback,
    pageInfo = undefined,
    sortInfo = undefined
  ) {
    const url = parent._links.children.href;
    return this.getEntitiesWithParams(
      url,
      pageInfo,
      sortInfo,
      callback,
      failureCallback
    );
  }

  getClassification(classification, callback, failureCallback) {
    const url = classification._links.self.href;
    return this.getEntitiesByUrl(url, callback, undefined, failureCallback);
  }

  getEntitiesUrl = () => {
    return this.urlFactory.classificationsUrl();
  };

  getClassificationOccurrence = (pageInfo, dataCallback, failuteCallback) => {
    const url = this.urlFactory.classificationsOccurenceUrl();

    return this.getEntitiesWithParams(
      url,
      pageInfo,
      undefined,
      dataCallback,
      failuteCallback
    );
  };
}

export default ClassificationService;
